import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiTrackLookup } from '@/entities/tracking/modules/api/tracking';

export const useTrackLookup = (trekId: string, enabled: boolean) =>
  useQuery({
    queryKey: queryKeys.tracking.lookup(trekId),
    queryFn: () => apiTrackLookup(trekId),
    enabled: enabled && trekId.length > 0,
    staleTime: 30_000,
    retry: false,
  });
